<div class="p-8">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-3xl font-bold text-gray-900">Articles</h1>
    <button (click)="addArticle()" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
      Add New Article
    </button>
  </div>
  
  <app-spinner *ngIf="loading"></app-spinner>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Author</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let article of orderedArticles" class="hover:bg-gray-50">
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <img *ngIf="article.thumbnail?.sm" [src]="article.thumbnail.sm" class="w-10 h-10 rounded object-cover mr-3">
              <span class="text-sm font-medium text-gray-900">{{ article.title }}</span>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ article.author || '—' }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ article.articleDate ? (article.articleDate | date:'d MMM y') : '—' }}</td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" 
                  [ngClass]="article.published ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
              {{ article.published ? 'Published' : 'Draft' }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <button (click)="editArticle(article._id)" class="text-blue-600 hover:text-blue-900 mr-4">Edit</button>
            <button (click)="confirmDelete(article)" class="text-red-600 hover:text-red-900">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="orderedArticles.length === 0" class="p-8 text-center text-gray-500">
      No articles yet. Click "Add New Article" to create one.
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete Article"
  [message]="'Are you sure you want to delete ' + (articleToDelete?.title || 'this article') + '?'"
  confirmText="Delete"
  (confirm)="deleteArticle()"
  (cancel)="cancelDelete()">
</app-confirmation-modal>
